module.exports = __webpack_public_path__ + "static/createaction-logo-b113e08cdadf32e23ddc8187592af624.jpg";